<template>
  <svg
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 489.039 489.039"
    width="24"
    height="24"
    xml:space="preserve"
  >
    <g>
      <g>
        <circle cx="244.52" cy="244.52" r="155.782" />
        <polygon points="244.52,0 200.759,68.495 288.282,68.495 " />
        <polygon points="420.547,200.759 420.547,288.282 489.039,244.52 " />
        <polygon points="244.52,489.039 288.282,420.547 200.759,420.547 " />
        <polygon points="68.495,200.759 0,244.52 68.495,288.282 " />
        <polygon points="417.422,71.618 338.045,89.108 399.934,150.995 " />
        <polygon points="417.422,417.422 399.934,338.045 338.045,399.934 " />
        <polygon points="89.108,338.045 71.618,417.422 150.995,399.934 " />
        <polygon points="150.995,89.108 71.618,71.618 89.108,150.995 " />
      </g>
    </g>
  </svg>
</template>

<style lang="scss" scoped>
svg {
  &:hover {
      border-radius: 10px;
    }
  circle,polygon {
    fill: var(--theme-toggle-bg);
  }
}
</style>
